<input
  type="text"
  autocomplete="off"
  class="date-input"
  [disabled]="disabled"
  [class.disabled]="disabled"
  [class.form-error-border]="error"
  [attr.id]="controlId"
  [value]="value"
  [placeholder]="placeholder"
  [maskito]="maskitoOptions"
  (input)="handleInput($event)" />
